module.exports = __webpack_public_path__ + "img/ic-delete.14a562bb.svg";